const cleanFieldValue = (fieldValue, emptyLabel) => {
  let cleanedValue = '';

  if (fieldValue && typeof fieldValue === 'string') {
    cleanedValue = fieldValue;
  }
  else if (fieldValue && fieldValue.length) {
    cleanedValue = fieldValue.map((item, index) => {
      return index > 0 ? `, ${item}` : item;
    });
  }
  else {
    cleanedValue = emptyLabel;
  }
  return cleanedValue;
};

export default cleanFieldValue;
